import styled from 'styled-components';
import device from '../../../styles/mediaSizes';

export const StyledSliderArea2 = styled.div`
  .hero-slider-wrapper {
    position: relative;
    z-index: 5;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 90vh;
    min-height: 700px;
    background-color: #0777bd1f;
    .hero-col-1 {
      display: flex;
      flex-direction: column;
      width: 75%;
      .hero-text-group {
        width: 20vw;
        min-width: 580px;
        height: 100%;
        margin: auto;
        padding-bottom: 10%;
        .hero-text-title {
        }
        .hero-text-description {
        }
        .button-group {
          .btn-default {
            margin-left: 0;
            .icon {
              display: none;
            }
          }
        }
      }
      .abide-logos-wrapper {
        display: flex;
        align-items: center;
        background-color: #fff;
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 10vh;
        min-height: 80px;
        .abide-logos-title {
          flex-shrink: 3;
          font-size: 14px;
          line-height: 20px;
          margin-left: 5%;
          margin-bottom: 6px;
        }
        .abide-logos-rows {
          width: 80%;
          margin-left: 1%;
          .abide-logos-row {
            display: flex;
            justify-content: space-between;
            .abide-img-wrapper {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 16.6%;
              .abide-logo-img {
                max-height: 50px;
              }
            }
          }
        }
      }
    }
    .slick-slider,
    .hero-col-2 {
      width: 25%;
      align-self: start;
      .slick-list {
        .slick-track {
          .slick-slide {
            .slick-content-wrapper {
              .slick-single-content {
                height: 80vh;
                min-height: 620px;
                display: flex;
                .slick-content-image {
                  width: 100%;
                  background-repeat: no-repeat;
                  background-size: cover;
                  background-position: center;
                }
                .slick-border-lines-wrapper {
                  display: flex;
                  justify-content: start;
                  align-items: start;
                  flex-direction: column;
                  .line-1 {
                    width: 5px;
                    height: 41%;
                    background-color: #feb25c;
                  }
                  .line-2 {
                    width: 5px;
                    height: 59%;
                    background-color: #0777db;
                  }
                }
              }
            }
          }
        }
      }
      .slick-dots {
        bottom: 2%;
        li {
          width: 30px;
          margin: 0;
          opacity: 1;
          position: relative;
          button {
            &::before {
              font-size: 10px;
              color: #0777db;
            }
            &::after {
            }
          }
        }
      }
      li.slick-active {
        button {
          &::after {
          }
        }
      }
    }

    @media ${device.lg} {
      & {
        height: 70vh;
        min-height: 600px;
        .hero-col-1 {
          .hero-text-group {
            .hero-text-title {
            }
            .hero-text-description {
            }
            .button-group {
              .btn-default {
                .icon {
                }
              }
            }
          }
          .abide-logos-wrapper {
            min-height: 85px;
            .abide-logos-title {
              width: 12%;
              margin-left: 4%;
              margin-bottom: 0;
            }
            .abide-logos-rows {
              .abide-logos-row {
                .abide-img-wrapper {
                  .abide-logo-img {
                  }
                }
              }
            }
          }
        }
        .slick-slider,
        .hero-col-2 {
          .slick-list {
            .slick-track {
              .slick-slide {
                .slick-content-wrapper {
                  .slick-single-content {
                    height: 60vh;
                    min-height: 514px;
                    .slick-content-image {
                    }
                    .slick-border-lines-wrapper {
                      .line-1 {
                      }
                      .line-2 {
                      }
                    }
                  }
                }
              }
            }
          }
          .slick-dots {
            li {
              button {
                &::before {
                }
                &::after {
                }
              }
            }
          }
          li.slick-active {
            button {
              &::after {
              }
            }
          }
        }
      }
    }

    @media ${device.md} {
      & {
        height: 70vh;
        min-height: 600px;
        .hero-col-1 {
          width: 70%;
          .hero-text-group {
            min-width: 400px;
            .hero-text-title {
            }
            .hero-text-description {
            }
            .button-group {
              .btn-default {
                .icon {
                }
              }
            }
          }
          .abide-logos-wrapper {
            min-height: 85px;
            .abide-logos-title {
              font-size: 12px;
              width: 12%;
              margin-left: 3%;
              margin-bottom: 0;
            }
            .abide-logos-rows {
              .abide-logos-row {
                .abide-img-wrapper {
                  .abide-logo-img {
                  }
                }
              }
            }
          }
        }
        .slick-slider,
        .hero-col-2 {
          width: 30%;
          .slick-list {
            .slick-track {
              .slick-slide {
                .slick-content-wrapper {
                  .slick-single-content {
                    height: 60vh;
                    min-height: 514px;
                    .slick-content-image {
                    }
                    .slick-border-lines-wrapper {
                      .line-1 {
                      }
                      .line-2 {
                      }
                    }
                  }
                }
              }
            }
          }
          .slick-dots {
            li {
              button {
                &::before {
                }
                &::after {
                }
              }
            }
          }
          li.slick-active {
            button {
              &::after {
              }
            }
          }
        }
      }
    }
    @media ${device.sm} {
      & {
        height: fit-content;
        min-height: auto;
        flex-direction: column-reverse;
        .hero-col-1 {
          height: 100%;
          width: 100%;
          .hero-text-group {
            min-width: 300px;
            padding-bottom: 90px;
            .hero-text-title {
              font-size: 30px;
            }
            .hero-text-description {
              font-size: 14px;
            }
            .button-group {
              .btn-default {
                display: flex;
                justify-content: center;
                align-items: center;
                height: 35px;
                font-size: 12px;
                margin-top: 25px;
                .icon {
                }
              }
            }
          }
          .abide-logos-wrapper {
            height: auto;
            min-height: 65px;
            flex-wrap: wrap;
            .abide-logos-title {
              width: 100%;
              margin-left: 4%;
              margin-bottom: 0;
              align-self: end;
            }
            .abide-logos-rows {
              width: 100%;
              align-self: start;
              .abide-logos-row {
                .abide-img-wrapper {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  width: 16.6%;
                  .abide-logo-img {
                    height: 50%;
                  }
                }
              }
            }
          }
        }
        .slick-slider,
        .hero-col-2 {
          margin-bottom: 35px;
          width: 100%;
          .slick-list {
            .slick-track {
              .slick-slide {
                .slick-content-wrapper {
                  .slick-single-content {
                    height: 200px;
                    min-height: auto;
                    .slick-content-image {
                    }
                    .slick-border-lines-wrapper {
                      .line-1 {
                      }
                      .line-2 {
                      }
                    }
                  }
                }
              }
            }
          }
          .slick-dots {
            display: none;
            li {
              display: none;
              button {
                &::before {
                }
                &::after {
                }
              }
            }
          }
          li.slick-active {
            button {
              &::after {
              }
            }
          }
        }
      }
    }
  }
`;

// .slider-area {
//   background-color: #0777db0d;
//   height: 90vh;
//   @media ${device.lg} {
//     height: auto;
//   }
// }

// .bg_image,
// .bgImagePosition {
//   height: 90vh;
//   /* background-attachment: fixed !important; */
//   background-repeat: no-repeat;
//   background-size: cover;
//   background-position: center center;
//   @media ${device.sm} {
//     height: 650px;
//   }
// }

// @-webkit-keyframes fadeInUp {
//   0% {
//     opacity: 0;
//     -webkit-transform: translate3d(0, 10%, 0);
//     transform: translate3d(0, 10%, 0);
//   }
//   to {
//     opacity: 1;
//     -webkit-transform: none;
//     transform: none;
//   }
// }
// @keyframes fadeInUp {
//   0% {
//     opacity: 0;
//     -webkit-transform: translate3d(0, 10%, 0);
//     transform: translate3d(0, 10%, 0);
//   }
//   to {
//     opacity: 1;
//     -webkit-transform: none;
//     transform: none;
//   }
// }
// .fadeInUp {
//   -webkit-animation-name: fadeInUp;
//   animation-name: fadeInUp;
// }

// .slider-image {
//   position: relative;
//   overflow: hidden;
//   height: 90vh;
//   width: 100%;
//   background-size: cover;
//   background-repeat: no-repeat;
//   background-position: center;
//   /* border-left: 4px solid #800a889f; */
//   @media ${device.lg} {
//     height: auto;
//   }
// }

// .slider-text-group {
//   position: relative;
//   left: 100px;
//   /* margin: 15%; */
// }

// .slider-dec-img-wrapper {
//   position: relative;
//   left: -200px;
// }

// .slider-fadeIn {
//   overflow: visible;
//   position: absolute;
//   height: 400px;
//   left: 0;
// }

// .slider-title {
//   margin-bottom: 25px;
//   line-height: 95px;
//   font-size: 85px;
//   max-width: 450px;
// }

// .slick-current.slick-active .slider-title {
//   animation: 2s fadeInUp;
// }

// .slider-subtitle {
//   font-family: 'Prompt', sans-serif;
//   font-size: 22px;
//   color: #5f5a6a;
// }

// .slider-description {
//   line-height: 32px;
//   font-size: 16px;
//   font-weight: 500;
//   max-width: 450px;
// }

// .orange-line {
//   width: 100%;
//   height: 41%;
//   background-color: #feb25c;
// }

// .purple-line {
//   width: 100%;
//   height: 59%;
//   background-color: #0777db;
// }

// .lines-wrapper {
//   left: -2px;
//   position: absolute;
//   width: 8px;
//   height: 100%;
//   z-index: 10;
// }
